// extracted by mini-css-extract-plugin
module.exports =  {"tabsContainer":"tabsContainer_mwSuPYal","carbonTabsContainer":"carbonTabsContainer_vuJvcg06"};